import React, { useEffect, useRef, useState } from "react";
import Placeholder from "react-bootstrap/Placeholder";
import "./design";
import BANNER from "./components/banner";
import BODY from "./components/body";
import MenuImages from "./components/menu_images";

function App() {
	const [language, setLanguage] = useState("EN");
	const [currency, setCurrency] = useState(["AED", "درهم"]);
	const [direction, setDirection] = useState("ltr");
	const [activeTab, setActiveTab] = useState();
	const [filteredSubCategories, setFilteredSubCategories] = useState([]);
	const dataRefGen = useRef([]);
	const [loadingCategories, setLoadingCategories] = useState(true);
	const dataRefCat = useRef([]);
	const [loadingSubCategories, setLoadingSubCategories] = useState(true);
	const dataRefSubCat = useRef([]);
	const [loadingProducts, setLoadingProducts] = useState(true);
	const dataRefProducts = useRef([]);
	const dataRefProductsAr = useRef([]);
	const [imageMenu, setimageMenu] = useState(false);
	const [imageMenuPath, setimageMenuPath] = useState("");
	const [imageMenuCount, setimageMenuCount] = useState(0);

	function handleLanguage(lang) {
		setLanguage(lang);
		if (lang === "AR") setDirection("rtl");
		else setDirection("ltr");
	}

	useEffect(() => {
		var url_string = window.location.href;
		var url = new URL(url_string);
		var slugurl = url.searchParams.get("slug");

		// AWJ EPPCO KITCHEN
		if (slugurl === "operationfalafelenoc") {
			window.location.replace(
				"https://pay.kitopi.com/en/menu?outletId=8e2d111f-3993-4723-9e50-db0fe3b83504&brandId=f9d5d209-c90f-4a25-9b2e-52465c4ffdfc",
			);
			return;
		}
		// AWJ OF DUBAI HILLS MALL
		if (slugurl === "operationfalafeldhm") {
			window.location.replace(
				"https://pay.kitopi.com/en/menu?outletId=6dbb2fe6-164d-4b6f-baa6-f919a2325289&brandId=f9d5d209-c90f-4a25-9b2e-52465c4ffdfc",
			);
			return;
		}
		// AWJ OF DFC
		if (slugurl === "operationfalafeleppco") {
			window.location.replace(
				"https://pay.kitopi.com/en/menu?outletId=11e8a016-144e-4d70-9691-bcff3763f21b&brandId=f9d5d209-c90f-4a25-9b2e-52465c4ffdfc",
			);
			return;
		}

   //Operation Falafel Ajdan Walk Khob 
   if (slugurl === "operationfalafelajdanwalk") {
	window.location.replace(
		"https://pay.kitopi.com/en/menu?outletId=795cb50f-3fc3-4926-a839-c66582ab3aef&brandId=f9d5d209-c90f-4a25-9b2e-52465c4ffdfc",
	);
	return;
}


 // Operation Falafel Alia Plaza
if (slugurl === "operationfalafelaliaplaza") {
    window.location.replace(
        "https://pay.kitopi.com/en/menu?outletId=3f85f2b6-cabd-413f-a958-fc49205dac57&brandId=f9d5d209-c90f-4a25-9b2e-52465c4ffdfc",
    );
    return;
}

// Operation Falafel Centro Manar
if (slugurl === "operationfalafelcentro") {
    window.location.replace(
        "https://pay.kitopi.com/en/menu?outletId=d79e2721-e675-4b00-9b4e-30f88231ee1c&brandId=f9d5d209-c90f-4a25-9b2e-52465c4ffdfc",
    );
    return;
}

// Operation Falafel Makkah
//if (slugurl === "operationfalafelmecca") {
    //window.location.replace(
     //   "https://pay.kitopi.com/menu?outletId=6cdd91ba-8ac9-47fb-a997-3786f83bb497&brandId=f9d5d209-c90f-4a25-9b2e-52465c4ffdfc",
    //);
   // return;
//}
// Operation Falafel Fayfa Rawda Jeddah
if (slugurl === "operationfalafelfayfa") {
    window.location.replace(
        "https://pay.kitopi.com/en/menu?outletId=e92afbe3-30c2-41e4-9fd7-d92ae4be4d5d&brandId=f9d5d209-c90f-4a25-9b2e-52465c4ffdfc",
    );
    return;
}

// Operation Falafel Joy Avenue Riyadh
if (slugurl === "operationfalafeljoyavenue") {
    window.location.replace(
        "https://pay.kitopi.com/en/menu?outletId=0c747e58-1dff-4828-a821-64cf16f6bcaf&brandId=f9d5d209-c90f-4a25-9b2e-52465c4ffdfc",
    );
    return;
}

// Operation Falafel Mercato Plaza
if (slugurl === "operationfalafelmercato") {
    window.location.replace(
        "https://pay.kitopi.com/en/menu?outletId=2e8ff839-b303-4755-8385-c05bee3579ac&brandId=f9d5d209-c90f-4a25-9b2e-52465c4ffdfc",
    );
    return;
}

// Operation Falafel Prince Sultan
if (slugurl === "operationfalafelprincesultan") {
    window.location.replace(
        "https://pay.kitopi.com/en/menu?outletId=dbc9b3e4-be13-44c7-b0fd-90ce6fc7a793&brandId=f9d5d209-c90f-4a25-9b2e-52465c4ffdfc",
    );
    return;
}
// Operation Falafel Quadisiya
if (slugurl === "operationfalafelqadisiya") {
    window.location.replace(
        "https://pay.kitopi.com/en/menu?outletId=c570985f-98e2-4a97-814f-4b98e4bfef5b&brandId=f9d5d209-c90f-4a25-9b2e-52465c4ffdfc",
    );
    return;
}

// Operation Falafel Rubeen Plaza
if (slugurl === "operationfalafelrubeenplaza") {
    window.location.replace(
        "https://pay.kitopi.com/en/menu?outletId=8eeac926-febc-482e-9bb2-8a6653546b67&brandId=f9d5d209-c90f-4a25-9b2e-52465c4ffdfc",
    );
    return;
}

// Operation Falafel Shati Al Gharbi -- Siddhant Kapoor said its same as Damman, so used Damman url
if (slugurl === "operationfalafeldammam") {
    window.location.replace(
        "https://pay.kitopi.com/en/menu?outletId=2cae2618-6e02-4a1a-8985-4c4c613ac3c4&brandId=f9d5d209-c90f-4a25-9b2e-52465c4ffdfc",
    );
    return;
}
//Operation Falafel Tahlia
if (slugurl === "operationfalafeltahlia") {
	window.location.replace(
		"https://pay.kitopi.com/en/menu?outletId=e0683a17-7790-4575-8e4d-997a8bbd9084&brandId=f9d5d209-c90f-4a25-9b2e-52465c4ffdfc",
	);
	return;
}
		if (
			slugurl === "operationfalafeldhm" ||
			slugurl === "operationfalafeleppco" ||
			slugurl === "operationfalafelenoc"
		) {
			setimageMenu(true);
			switch (slugurl) {
				case "operationfalafeldhm":
					setimageMenuPath("../menu-images/dhm/");
					setimageMenuCount(8);
					break;
				case "operationfalafeleppco":
					setimageMenuPath("../menu-images/eppco/");
					setimageMenuCount(8);
					break;
				case "operationfalafelenoc":
					setimageMenuPath("../menu-images/enoc/");
					setimageMenuCount(8);
					break;
				default:
					break;
			}
		} else {
			fetch(
				"https://qrportalbackend.azurewebsites.net/generation/outlet/" +
					slugurl,
			)
				.then((response) => response.json())
				.then((data) => {
					dataRefGen.current = data;
					const slugGeneration = dataRefGen.current[0]["Generation"];
					if (
						slugGeneration === 35 ||
						slugGeneration === 36 ||
						slugGeneration === 37 ||
						slugGeneration === 38 ||
						slugGeneration === 39 ||
						slugGeneration === 42 ||
						slugGeneration === 43 ||
						slugGeneration === 44 ||
						slugGeneration === 45 ||
						slugGeneration === 51 ||
						slugGeneration === 52 ||
						slugGeneration === 53 ||
						slugGeneration === 54 ||
						slugGeneration === 63 ||
						slugGeneration === 66
					)
						setCurrency(["SAR", "ريال"]);
					else setCurrency(["AED", "درهم"]);
					fetch(
						"https://qrportalbackend.azurewebsites.net/category/outlet/lvl1/" +
							slugGeneration,
					)
						.then((response) => response.json())
						.then((data) => {
							dataRefCat.current = data;
							setLoadingCategories(false);
						})
						.catch((error) => console.log(error));
					fetch(
						"https://qrportalbackend.azurewebsites.net/category/outlet/lvl2/" +
							slugGeneration,
					)
						.then((response) => response.json())
						.then((data1) => {
							dataRefSubCat.current = data1;
							setLoadingSubCategories(false);
						})
						.catch((error) => console.log(error));
					fetch(
						"https://qrportalbackend.azurewebsites.net/menu/outlet/" +
							slugGeneration +
							"/1",
					)
						.then((response) => response.json())
						.then((data2) => {
							dataRefProducts.current = data2;
							fetch(
								"https://qrportalbackend.azurewebsites.net/menu/outlet/" +
									slugGeneration +
									"/2",
							)
								.then((response) => response.json())
								.then((data2Ar) => {
									dataRefProductsAr.current = data2Ar;
									setLoadingProducts(false);
									setActiveTab(dataRefCat.current[0].Id);
									const subcats = dataRefSubCat.current.filter(
										(item) =>
											item.ParentCategoryID === dataRefCat.current[0].Id,
									);
									setFilteredSubCategories(subcats);
								})
								.catch((error) => console.log(error));
						})
						.catch((error) => console.log(error));
				})
				.catch((error) => console.log(error));
		}
		// eslint-disable-next-line
	}, []);

	function handleNav1Click(catId) {
		setActiveTab(catId);
		const subcats = dataRefSubCat.current.filter(
			(item) => item.ParentCategoryID === catId,
		);
		setFilteredSubCategories(subcats);
	}

	return (
		<div className="App">
			{!imageMenu ? (
				<BANNER
					handleLanguage={handleLanguage}
					language={language}
					direction={direction}
					currency={currency}
				/>
			) : (
				""
			)}
			{imageMenu ? (
				<MenuImages path={imageMenuPath} imagecount={imageMenuCount} />
			) : !loadingProducts ? (
				<BODY
					activeTab={activeTab}
					direction={direction}
					categories={dataRefCat.current}
					loadingCategories={loadingCategories}
					subCategories={filteredSubCategories}
					loadingSubCategories={loadingSubCategories}
					products={dataRefProducts.current}
					productsAr={dataRefProductsAr.current}
					loadingProducts={loadingProducts}
					handleNav1Click={handleNav1Click}
					language={language}
					currency={currency}
				/>
			) : (
				<Placeholder as="p" animation="glow">
					<Placeholder className="vh-100" xs={12} size="lg" />
				</Placeholder>
			)}
		</div>
	);
}

export default App;
